// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__CiCvp","slick-next":"CustomSlider_slick-next__OLdju"};